import { sendRequest } from '../api/websocketApi';
import useStore from '../store/store';

export interface Member {
    MemberId: number;
    FirstName: string;
    LastName: string;
    Sex: 'male' | 'female';
    BirthDate: Date | string;
    PatientId?: string;
    InsertionDate?: Date | string;
    ReadyKitCount: number;
    InProgressKitCount: number;
    ReferringPhysician?: string;
    Ethnicity?: string;
}

interface APIResponse {
    success: boolean;
    errCode?: 'invalid_token' | 'auth_failed';
    errDetails?: string;
    members?: Member[];
}

const GetMembers = () => {
    const setIsLoading = useStore.getState().setIsLoading;
    const setMembers = useStore.getState().setMembers;
    const setFormError = useStore.getState().setFormError;

    setIsLoading(true);
    sendRequest(
        {
            endpoint: '/member/get-all',
        },
        (data: APIResponse) => {
            const { success, errCode, members, errDetails } = data;
            if (success && Array.isArray(members)) {
                setMembers(members);
                setIsLoading(false);
            } else {
                setMembers([]);
                setIsLoading(false);
                setFormError('');
                if (errCode) {
                    setTimeout(() => setFormError(errCode), 0);
                    console.error(errCode);
                    if (errDetails) console.error(errDetails);
                }
            }
        }
    );
};

export default GetMembers;
